import { createInstance } from 'localforage';

export const createLocalDatabase = (repoName: string) =>
  createInstance({
    name: 'data-collection/apps/client-web',
    storeName: repoName,
  });
